// extracted by mini-css-extract-plugin
export default {"form":"AddExpenseForm_form__ZWGJV","form_overlay":"AddExpenseForm_form_overlay__4Tdef"};